import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import blogsData from "../constants/blogsData";
import type { BlogPost } from "../types/blog";
import BlogPostHeader from "../components/BlogPost/BlogPostHeader";
import BlogPostContent from "../components/BlogPost/BlogPostContent";
import RelatedPosts from "../components/BlogPost/RelatedPosts";
import { Navbar } from "../components/Navbar";
import Footer from "../components/Footer";
import { normalizeBlogSlug } from "../helpers/pathUtils";

const BlogPostPage = () => {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  // Find the current post by slug or id fallback
  const typedBlogsData = blogsData as unknown as BlogPost[];
  const normalizedParam = normalizeBlogSlug(slug);
  const currentPost = typedBlogsData.find((post) => {
    const normalizedPostSlug = normalizeBlogSlug(post.slug || post.id);
    return normalizedPostSlug === normalizedParam || post.id === slug;
  });

  if (!currentPost) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-xl">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            Post Not Found
          </h2>
          <p className="text-gray-600">
            The blog post you&apos;re looking for doesn&apos;t exist.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen pt-32">
      <Navbar />
      {/* Hero Section */}
      {/* <section
        className="flex items-center justify-center overflow-hidden pt-20"
        style={{
          backgroundImage: `url(${IMAGES.EPC_1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
        >
        <div className="flex aspect-3/1 h-auto w-full items-center justify-center bg-black/40 py-6 sm:py-10 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="relative z-10 mx-auto max-w-440 px-4 py-5 text-center sm:px-5 sm:py-10 md:px-6 md:py-12 lg:px-10 2xl:px-20"
          >
            <h1 className="mb-[0.5em] text-center text-2xl font-bold text-white sm:text-4xl md:text-5xl">
              Thoughts That Power Progress
            </h1>
            <p className="mx-auto mb-[2em] max-w-3xl text-center text-sm text-white/90 sm:text-base md:text-lg">
              Ideas, updates, and stories shaping digital transformation.
            </p>
          </motion.div>
        </div>
      </section> */}
      <div className="max-w-440 mx-auto px-4 mt-10 lg:px-10 2xl:px-20">
        <BlogPostHeader post={currentPost} />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 py-10">
          {/* Main Content */}
          <div className="lg:col-span-8">
            <BlogPostContent post={currentPost} />
            <RelatedPosts currentPost={currentPost} />
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4">
            <Sidebar />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogPostPage;
